module.exports = __webpack_public_path__ + "fasaw8.png?c012ad69fa8b110b14af0a4d73143af1";